import baseApi from './baseApi';
// Define a service using a base URL and inject endpoints
export const userInfoApi = baseApi.injectEndpoints({
    endpoints: (builder) => ({
        getUserInfo: builder.query({
            query: (siteId) => `/api/sites/${siteId}/accountInfo?context=member`,
            providesTags: ['User'],
        }),
        getUserId: builder.query({
            query: (siteId) => `/api/sites/${siteId}/accountInfo?context=member`,
            transformResponse: (userInfo) => {
                const { user } = userInfo;
                return user.id;
            },
        }),
    }),
});
// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useGetUserIdQuery, useLazyGetUserIdQuery, useGetUserInfoQuery } = userInfoApi;
